import script from "./wavePlayer.vue?vue&type=script&setup=true&lang=ts"
export * from "./wavePlayer.vue?vue&type=script&setup=true&lang=ts"

import "./wavePlayer.vue?vue&type=style&index=0&id=417eb01d&lang=less"

const __exports__ = script;

export default __exports__